/**
 * Created by DejanK on 8/3/2017.
 *
 * rbHasUppercase
 *
 * Validates that input has uppercase character
 */

export default rbHasUppercase;

function rbHasUppercase() {
  return {
    require: 'ngModel',
    link: (s, e, attrs, ngModelCtrl)=>{
      ngModelCtrl.$validators.rbHasUppercase = (modelValue, viewValue)=>{
        const pattern = /(?=\S*?[A-Z])/;
        return pattern.test(modelValue || viewValue);
      }
    }
  }
}
